module.exports = __webpack_public_path__ + "img/green-arrow.d6ac0d39.svg";